/* tslint:disable */

declare var Object: any;
export interface TeodemppersonalInterface {
  "empId": string;
  "birthplace"?: string;
  "birthdate"?: Date;
  "nationalityCode"?: string;
  "religionCode"?: string;
  "raceCode"?: string;
  "identityNo"?: string;
  "identityExpdate"?: Date;
  "salutationCode"?: string;
  "dialectCode"?: string;
  "maritalstatus": number;
  "marriedDate"?: Date;
  "marriedPlace"?: string;
  "phone"?: string;
  "edutitle1"?: string;
  "edutitle2"?: string;
  "gmtId"?: number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "phoneExt"?: string;
  "notes"?: string;
  rel_personal?: any;
}

export class Teodemppersonal implements TeodemppersonalInterface {
  "empId": string;
  "birthplace": string;
  "birthdate": Date;
  "nationalityCode": string;
  "religionCode": string;
  "raceCode": string;
  "identityNo": string;
  "identityExpdate": Date;
  "salutationCode": string;
  "dialectCode": string;
  "maritalstatus": number;
  "marriedDate": Date;
  "marriedPlace": string;
  "phone": string;
  "edutitle1": string;
  "edutitle2": string;
  "gmtId": number;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "phoneExt": string;
  "notes": string;
  rel_personal: any;
  constructor(data?: TeodemppersonalInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Teodemppersonal`.
   */
  public static getModelName() {
    return "Teodemppersonal";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Teodemppersonal for dynamic purposes.
  **/
  public static factory(data: TeodemppersonalInterface): Teodemppersonal{
    return new Teodemppersonal(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Teodemppersonal',
      plural: 'Teodemppersonals',
      path: 'Teodemppersonals',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "birthplace": {
          name: 'birthplace',
          type: 'string'
        },
        "birthdate": {
          name: 'birthdate',
          type: 'Date'
        },
        "nationalityCode": {
          name: 'nationalityCode',
          type: 'string'
        },
        "religionCode": {
          name: 'religionCode',
          type: 'string'
        },
        "raceCode": {
          name: 'raceCode',
          type: 'string'
        },
        "identityNo": {
          name: 'identityNo',
          type: 'string'
        },
        "identityExpdate": {
          name: 'identityExpdate',
          type: 'Date'
        },
        "salutationCode": {
          name: 'salutationCode',
          type: 'string'
        },
        "dialectCode": {
          name: 'dialectCode',
          type: 'string'
        },
        "maritalstatus": {
          name: 'maritalstatus',
          type: 'number'
        },
        "marriedDate": {
          name: 'marriedDate',
          type: 'Date'
        },
        "marriedPlace": {
          name: 'marriedPlace',
          type: 'string'
        },
        "phone": {
          name: 'phone',
          type: 'string'
        },
        "edutitle1": {
          name: 'edutitle1',
          type: 'string'
        },
        "edutitle2": {
          name: 'edutitle2',
          type: 'string'
        },
        "gmtId": {
          name: 'gmtId',
          type: 'number'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "phoneExt": {
          name: 'phoneExt',
          type: 'string'
        },
        "notes": {
          name: 'notes',
          type: 'string'
        },
      },
      relations: {
        rel_personal: {
          name: 'rel_personal',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Teodemppersonal.ts